<template>
	<div class="sentiment-cyclicality-year">
		<SentimentMarketCombined zoom_start="50" />
	</div>
</template>

<script>
	import SentimentMarketCombined from 'components/sentiment/SentimentMarketCombined.vue'

	export default {
		name: 'SentimentCyclicalityYear',
		components: {
			SentimentMarketCombined
		},
		data() {
			return {}
		}
	}
</script>

<style scoped>

</style>
